import React from 'react'
import "./color.css"

function RedP() {
    var x = localStorage.getItem("percentage protein")
    return (
        <div className = "red__background">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default RedP
